import { Component, Input, OnChanges } from '@angular/core';
import { SLEntityVersion } from '../entity';
import { filter, isEmpty, uniq, last, forEach, map } from 'lodash';

function buildMovements(ev: SLEntityVersion, showHidden: boolean, accountId: string  = null) {
  const movements = ev.movementsLedger.movements.map((m: any) => {

    const lines: any[] = [];
    let balances: any [] = m.balances;

    let credits = m.credits;
    let debits = m.debits;

    if (accountId) {
      credits = filter(credits, c => c.account.id === accountId);
      debits = filter(debits, d => d.account.id === accountId);
    }
    
    const maxi = Math.max(credits.length, debits.length);
    
    for (let i = 0; i < maxi; i++) {
      if (!showHidden) {
        credits = filter(credits, c => c.isHidden !== true);
        debits = filter(debits, d => d.isHidden !== true);
      }
      
      const line: any = {
        credit: i < credits.length ? credits[i] : null,
        debit: i < debits.length ? debits[i] : null,
      }

      if (accountId) {
        line.natures = uniq(filter([line.debit ? line.debit.nature : null, line.credit ? line.credit.nature : null], n => !isEmpty(n)));

        // Add balances
        balances = [];
  
        forEach(m.balances[accountId].items, (val, key) => {
          if (val !== '0') {
            const [ownership, shareType] = key.split('_');
    
            balances.push({
              ownership,
              shareType,
              amount: val,
            });
          }
        });
      }

      if (!(i > 0 && line.credit == null && line.debit == null)) {
        lines.push(line);
      }
    }

    return {
      ...m,
      lines,
      balances,
    };
  });

  return filter(movements, m => m.lines.length > 0);
}

@Component({
  selector: 'sl-entity-movements-ledger',
  templateUrl: './entity-movements-ledger.component.html',
})
export class SLEntityMovementsLedgerComponent implements OnChanges {

  @Input()
  entity: SLEntityVersion

  @Input()
  showHidden: boolean = true

  movements: any
  accounts: any
  totalBalance: any
  capitalisation: any

  showColumn_PP_NP_AT_PREF: boolean
  showColumn_UF_ORD: boolean
  showColumn_UF_PREF: boolean
  
  ngOnChanges() {
    this.movements = buildMovements(this.entity, this.showHidden);
  
    this.accounts = this.entity.movementsLedger.accounts.map((a: any) => ({
      ...a,
      movements: buildMovements(this.entity, this.showHidden, a.id),
      balance: last<any>(this.movements).balances[a.id]
    }));
  
    this.totalBalance = this.entity.movementsLedger.totalBalance;

    this.capitalisation = this.entity.movementsLedger.capitalisation;

    this.showColumn_PP_NP_AT_PREF = this.capitalisation.PP_NP_AT_PREF !== '0';
    this.showColumn_UF_ORD = this.capitalisation.UF_ORD !== '0';
    this.showColumn_UF_PREF = this.capitalisation.UF_PREF !== '0';
  }
}
